const prod = process.env.REACT_APP_API_URL;
const dev = process.env.REACT_APP_API_URL_DEV;

export const API_URL = process.env.NODE_ENV === "development" ? dev : prod;


